import { Injectable } from '@angular/core';

export interface EnvironmentConfig {
  auth: string;
  client_id: string;
  env_type: string;
  realm: string;
  rest: string;
  rest_path: string;
}

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private _config!: EnvironmentConfig;

  set config(cfg: EnvironmentConfig) {
    this._config = cfg;
  }

  get config(): EnvironmentConfig {
    return this._config;
  }
}
